import type { PageBreadcrumbItem } from "@core/components/PageBreadcrumb";
import {
  PAGE_BREADCRUMB_LABELS,
  PAGE_BREADCRUMB_PATHS,
  PAGE_BREADCRUMB_REPORT_FALLBACK,
  PAGE_BREADCRUMB_TEST_IDS,
} from "@core/constants/pageBreadcrumb";

function joinBase(basePath: string, segment: string): string {
  return `${basePath.replace(/\/$/, "")}/${segment}`;
}

function resolveCurrentLabel(currentLabel?: string | null): string {
  const trimmed = (currentLabel ?? "").trim();
  return trimmed || PAGE_BREADCRUMB_REPORT_FALLBACK;
}

export function departmentsToReportTemplatesTrail(basePath: string): PageBreadcrumbItem[] {
  return [
    {
      label: PAGE_BREADCRUMB_LABELS.DEPARTMENTS,
      to: joinBase(basePath, PAGE_BREADCRUMB_PATHS.DEPARTMENTS),
      testId: PAGE_BREADCRUMB_TEST_IDS.DEPARTMENTS_LINK,
    },
    { label: PAGE_BREADCRUMB_LABELS.REPORT_TEMPLATES },
  ];
}

export function departmentReportsListToViewTrail(
  basePath: string,
  currentLabel?: string | null
): PageBreadcrumbItem[] {
  return [
    {
      label: PAGE_BREADCRUMB_LABELS.DEPARTMENT_REPORTS,
      to: joinBase(basePath, PAGE_BREADCRUMB_PATHS.DEPARTMENT_REPORTS_ALL),
    },
    { label: resolveCurrentLabel(currentLabel) },
  ];
}

export function pastorReportsListToViewTrail(
  basePath: string,
  currentLabel?: string | null
): PageBreadcrumbItem[] {
  return [
    {
      label: PAGE_BREADCRUMB_LABELS.PASTOR,
      to: joinBase(basePath, PAGE_BREADCRUMB_PATHS.PASTOR_REPORTS_ALL),
    },
    { label: resolveCurrentLabel(currentLabel) },
  ];
}

export function financeStatsListToViewTrail(
  basePath: string,
  currentLabel?: string | null
): PageBreadcrumbItem[] {
  return [
    {
      label: PAGE_BREADCRUMB_LABELS.FINANCE_STATISTICS,
      to: joinBase(basePath, PAGE_BREADCRUMB_PATHS.FINANCE_STATISTICS_REPORTS_ALL),
    },
    { label: resolveCurrentLabel(currentLabel) },
  ];
}

export function activitySubmissionsToEntryTrail(
  basePath: string,
  templateName: string
): PageBreadcrumbItem[] {
  return [
    {
      label: PAGE_BREADCRUMB_LABELS.ACTIVITY_SUBMISSIONS,
      to: joinBase(basePath, PAGE_BREADCRUMB_PATHS.ACTIVITY_SUBMISSIONS_ALL),
    },
    { label: templateName.trim() || PAGE_BREADCRUMB_REPORT_FALLBACK },
  ];
}

/** Nation Churches filtered by district name: Districts › {districtName}. */
export function districtsToFilteredChurchesTrail(
  basePath: string,
  districtName: string
): PageBreadcrumbItem[] {
  return [
    {
      label: PAGE_BREADCRUMB_LABELS.DISTRICTS,
      to: joinBase(basePath, PAGE_BREADCRUMB_PATHS.DISTRICTS),
      testId: PAGE_BREADCRUMB_TEST_IDS.DISTRICTS_LINK,
    },
    { label: districtName.trim() },
  ];
}
